// extracted by mini-css-extract-plugin
module.exports = {"link":"logo-link-module--link--Wxdqk","svg":"logo-link-module--svg--2tVs6","blob":"logo-link-module--blob--3qY-l"};